import FieldsTranslation from "graphql/fields/FieldsTranslation";

export default `
	guid
    created_at
    name
    credits_amount
    price
    status

    translations {
        ${FieldsTranslation}
    }
`;
